/**
 * Apollo client singleton for use in components rendered outside the main React tree
 * (e.g., GrapesJS modals that use ReactDOM.render)
 * 
 * This module exists to avoid circular dependencies when importing the client.
 */

import ApolloClient from 'apollo-client';

let apolloClientInstance: ApolloClient<any> | null = null;

/**
 * Set the Apollo client instance (called from src/index.tsx after client creation)
 */
export const setApolloClient = (client: ApolloClient<any>) => {
    apolloClientInstance = client;
};

/**
 * Get the Apollo client instance
 */
export const getApolloClient = (): ApolloClient<any> | null => {
    return apolloClientInstance;
};
